var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import Tus from "../../../../node_modules/.pnpm/@uppy_tus@4.2.2_@uppy_core@4.4.5/node_modules/@uppy/tus/lib/index.js";
import XHRUpload from "../../../../node_modules/.pnpm/@uppy_xhr-upload@4.3.3_@uppy_core@4.4.5/node_modules/@uppy/xhr-upload/lib/index.js";
import { unref } from "vue";
import { useFileManagerCommon } from "./useFileManagerCommon.js";
import get from "../../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js";
import isNil from "../../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js";
function useFileManagerSupabase(files, fileInputRef, emits, options) {
  const {
    uppy,
    errorMessage,
    setErrorMessage,
    texts,
    isDragOver,
    isDragging,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleDragStart,
    handleDragEnd,
    uploadAreaDirection,
    handleSelectFile,
    handleFileChange,
    handleDeleteFile,
    handleDownloadFile,
    getFileKey,
    getIcon
  } = useFileManagerCommon(files, fileInputRef, emits, options), opts = unref(options), { supabaseConfig, uploadType, headers } = opts;
  function generateFilePath(file) {
    const timestamp = Date.now(), random = Math.random().toString(36).substring(2, 8), ext = file.name.split(".").pop(), fileName = `${timestamp}-${random}.${ext}`;
    return supabaseConfig != null && supabaseConfig.basePath ? `${supabaseConfig.basePath}/${fileName}` : fileName;
  }
  return __name(generateFilePath, "generateFilePath"), uploadType === "tus" && supabaseConfig ? (uppy.use(Tus, {
    endpoint: opts.endpoint,
    // 使用完整的 endpoint，不需要添加 bucket name
    headers: {
      ...headers,
      "x-upsert": "true"
      // Supabase 特定的 header，允许覆盖现有文件
    },
    uploadDataDuringCreation: !0,
    // 重要：Supabase 需要这个选项
    removeFingerprintOnSuccess: !0,
    // 重要：允许重新上传相同的文件
    chunkSize: 6 * 1024 ** 2,
    // 必须是 6MB，Supabase 的要求
    retryDelays: [0, 3e3, 5e3, 1e4, 2e4],
    // 官方推荐的重试延迟
    allowedMetaFields: ["bucketName", "objectName", "contentType", "cacheControl"],
    // Supabase 允许的元数据字段
    onError(error) {
      console.error("TUS upload failed:", error), setErrorMessage(error.message || "Upload failed");
    }
  }), uppy.on("file-added", (file) => {
    if (!file)
      return;
    const filePath = generateFilePath(file.data), supabaseMetadata = {
      bucketName: supabaseConfig.bucketName,
      objectName: filePath,
      contentType: file.type || "application/octet-stream",
      cacheControl: "3600"
      // 可选：缓存控制
    };
    uppy.setFileMeta(file.id, {
      ...file.meta,
      ...supabaseMetadata
    });
  })) : uppy.use(XHRUpload, {
    endpoint: opts.endpoint,
    headers,
    timeout: opts.timeout
  }), uppy.on("upload-success", (file, response) => {
    var _a, _b, _c;
    if (!files.value)
      return;
    const index = files.value.findIndex((f) => f.uid === (file == null ? void 0 : file.id));
    if (index !== -1) {
      if (files.value[index].status = "success", uploadType === "tus" && supabaseConfig) {
        const objectName = (_a = file == null ? void 0 : file.meta) == null ? void 0 : _a.objectName, bucketName = (_b = file == null ? void 0 : file.meta) == null ? void 0 : _b.bucketName;
        objectName && (files.value[index].id = objectName, supabaseConfig.publicUrl && (files.value[index].url = `${supabaseConfig.publicUrl}/${bucketName}/${objectName}`));
      } else {
        let extractedId = null;
        const currentOpts = unref(options);
        if (currentOpts.idField)
          if (typeof currentOpts.idField == "function")
            extractedId = currentOpts.idField(response == null ? void 0 : response.body);
          else {
            const value = get(response == null ? void 0 : response.body, currentOpts.idField);
            extractedId = typeof value == "string" ? value : isNil(value) ? null : String(value);
          }
        else {
          const defaultValue = (_c = response == null ? void 0 : response.body) == null ? void 0 : _c.data;
          extractedId = typeof defaultValue == "string" ? defaultValue : isNil(defaultValue) ? null : String(defaultValue);
        }
        files.value[index].id = extractedId;
      }
      emits("success", files.value[index]);
    }
  }), {
    // 状态
    errorMessage,
    isDragOver,
    isDragging,
    uploadAreaDirection,
    // 文本和限制
    texts,
    // 方法
    handleSelectFile,
    handleFileChange,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleDeleteFile,
    getFileKey,
    getIcon,
    setErrorMessage,
    handleDragStart,
    handleDragEnd,
    handleDownloadFile
  };
}
__name(useFileManagerSupabase, "useFileManagerSupabase");
export {
  useFileManagerSupabase
};
//# sourceMappingURL=useFileManagerSupabase.js.map
